const secrets = {
    third_party_token_set: {
        token_not_found: '未找到令牌记录。',
        access_token_expired: '访问令牌已过期。 请重新连接你的账户。',
    },
};
export default Object.freeze(secrets);
